import React from 'react';
import { ProgressStep } from './progress_step.jsx';

//Progress menu on top on the page
// (1)-(2)-(3)-(4)
const ProgressMenu = ({active, steps, disabledSteps}) => {

    let stepItems = steps.map((step, index) => {
      let line;
      if(index != steps.length -1){
        line = (<div className="line" />);
      }

      let disabled;
      for(let step in disabledSteps){
        if (index+1 == disabledSteps[step]){
          disabled = true;
        }
      }

      return(
        <div className="progress-item" key={index} >
          <ProgressStep
            number={index+1}
            completed = {active >= index}
            active = {index === active}
            disabled = {disabled}
          />
          {line}
        </div>
      );
    });

    return (
      <div className="progress-menu">
        {stepItems}
      </div>
    );


};

export default ProgressMenu;
